import { render, staticRenderFns } from "./MonitorDetailView.vue?vue&type=template&id=7256b5fe"
import script from "./MonitorDetailView.vue?vue&type=script&lang=js"
export * from "./MonitorDetailView.vue?vue&type=script&lang=js"
import style0 from "./MonitorDetailView.vue?vue&type=style&index=0&id=7256b5fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports